import React from 'react'
import { Button } from 'react-bootstrap'
import useClientLocation from '../../../hooks/use-client-location'

const CreateReflectionPromptButton = () => {
    const { toLocation, endpoints } = useClientLocation()
    return (
        <Button size='lg' onClick={() => toLocation(endpoints.REFLECTION_PROMPT.replace(':reflectionPromptId', 'new'))} >New Reflection</Button>
    )
}

export default CreateReflectionPromptButton